<template>
	<div class="error-page">
		
		<!-- NavigationBar nur anzeigen, wenn der User eingeloggt ist -->
		<NavigationBar>
	      <template v-slot:center>
          <span data-testid="error-title">{{ $t('error_page.title') }}</span>
	      </template>
	    </NavigationBar>
        
        <div class="error-container">
        	<h1 data-testid="error-message">{{ $t('error_page.intro') }}</h1>
        	<p>{{ $t('error_page.text') }}</p>
            <router-link v-if="this.$store.state.user" to="/dashboard">
        		<button data-testid="error-home">{{ $t('menu.dashboard') }}</button>
        	</router-link>
        </div>
		
	</div>
</template>

<script>

	import NavigationBar from '../components/NavigationBar'

	export default {
    	name: 'ErrorPage',
    	components: { NavigationBar },
		mounted() {
			//window.parent.postMessage({func: 'betGameListener', message: '401'}, '*')
		},
	    methods: {
	      	openMenu () {
	        	this.$modal.show('betgame-menu')
	      	}
	    }
  	}

</script>

<style lang="scss" scoped>
	.error {

		&-page {
			display: flex;
		}

		&-container {
			display: flex;
			flex-direction: column;
			min-height: calc(100vh - 80px);
			width: 100%;
			align-items: center;
			justify-content: center;
			text-align: center;

			button {
				margin-top: 27px;
			}
		}
	}
</style>
